import React from 'react'
import PropTypes from 'prop-types'

const BoxTempPassword = ({ email }) => {
  return (
    <div className='col-12'>
      <h1 className='h1 login-title color-brand-1 txt-font-body mb-1'>Esqueceu a senha?</h1>
      <p className='txt-body-sm'>Sua senha ainda não foi definida.</p>
      <p className='txt-body-sm mb-1'>
        Verifique em seu e-mail cadastrado sua senha temporaria para acessar o sistema.
      </p>
      <div>
        <h2 className='custon-outline login-title txt-title-3 color-brand-1 txt-font-body mb-2 h3'>
          <span className='txt-bold color-brand-1'>{email}</span>
        </h2>
      </div>
    </div>
  )
}

BoxTempPassword.propTypes = {
  email: PropTypes.string
}

export default BoxTempPassword
